export const TITLE = 'Filters & Sort';

export const DIALOG_TITLE_ID = 'roundup-filters-dialog-title';
